import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from './Button';

import './Button.module.css';

class SuperButton extends PureComponent {
  render() {
    const { ctaText, buttonText, url } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        <div styleName="super-button">
          <p>{ctaText}</p>
          <Button arrow="none" color="light" url={url}>
            {buttonText}
          </Button>
        </div>
      </div>
    );
  }
}

SuperButton.propTypes = {
  ctaText: PropTypes.string,
  buttonText: PropTypes.string,
  url: PropTypes.string
};

export default SuperButton;
